import { Divider, Form } from 'antd';
import HiddenFormInput from '../../../../../components/Inputs/HiddenFormInput';
import OurClaimForm from '../../Components/Edit/Components/OverChargeDetails/OurClaimForm';
import YourClaimForm from '../../Components/Edit/Components/OverChargeDetails/YourClaimForm';

const CreateOverChargeDetails = ({ detailsForm, initialValues }) => {
  const claimDetails = Form.useWatch(null, detailsForm);
  return (
    <Form name="claimsDetailsForm" form={detailsForm} initialValues={initialValues}>
      <OurClaimForm editMode setEditMode={() => {}} claimDetails={claimDetails} form={detailsForm} />
      <Divider className="my-16 w-100" dashed />
      <YourClaimForm editMode setEditMode={() => {}} claimDetails={claimDetails} form={detailsForm} />
      <HiddenFormInput name="customerClaimNo" />
      <HiddenFormInput name="customerName" />
      <HiddenFormInput name="preparedBy" />
      <HiddenFormInput name="submittedBy" />
      <HiddenFormInput name="customerDisplayAddress" />
      <HiddenFormInput name="recoverySum" />
    </Form>
  );
};

export default CreateOverChargeDetails;
